 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-19077dac":"31348ff8","chunk-3a41d492":"5e76e3d4","chunk-626ba461":"722e7e8b","chunk-67e42083":"aa94bc72","chunk-67fad740":"7daddfd0","chunk-67fb6f57":"bc3036e1","chunk-7378afc2":"bfff7a7b","chunk-766bc744":"7fb83f36","chunk-3f7c25af":"36e1436a","chunk-271a77da":"b7e012e0","chunk-3526a310":"85c1c8c3","chunk-542ae368":"cb5c360f","chunk-743e4b25":"73613561","chunk-74524b79":"aa149a39","chunk-746154ec":"55c7829f","chunk-7498e9ec":"e1fc1f55","chunk-74a82e1a":"63f2aa9c","chunk-74b6aca8":"1db3cf23","chunk-2eb2cd53":"61caf165","chunk-76f08193":"8b34e8ec","chunk-771a7e38":"a931713b","chunk-7f466224":"cd1b4d8f","chunk-0069aa54":"6c0a8b84","chunk-297a20f0":"3474bcf0","chunk-4c24d0d2":"df643161","chunk-6a0d76fd":"ee3d5a2e","chunk-2d0d7a57":"4620b9a1","chunk-2d207762":"327ed383","chunk-4906ca31":"afea8778","chunk-6c336933":"f7259a28","chunk-4238b374":"43d67574","chunk-4b38d3e4":"ba0de6e7","chunk-ffbc6fd0":"e8a3ec70","chunk-85226048":"44cee004","chunk-f0163ed2":"868ad053","chunk-fdcdac8a":"de539c41","chunk-81498b9e":"2558d4e0","chunk-df0d8712":"8097294f","chunk-67e31440":"f7d5b9db","chunk-f42db444":"fb23ff6e","chunk-526b7efe":"83adf4e2","chunk-6966c2e6":"81c965fd","chunk-fd78add2":"c1634b74"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-19077dac":1,"chunk-3a41d492":1,"chunk-626ba461":1,"chunk-7378afc2":1,"chunk-766bc744":1,"chunk-3f7c25af":1,"chunk-271a77da":1,"chunk-3526a310":1,"chunk-542ae368":1,"chunk-743e4b25":1,"chunk-74524b79":1,"chunk-746154ec":1,"chunk-7498e9ec":1,"chunk-74a82e1a":1,"chunk-74b6aca8":1,"chunk-2eb2cd53":1,"chunk-76f08193":1,"chunk-771a7e38":1,"chunk-0069aa54":1,"chunk-297a20f0":1,"chunk-4c24d0d2":1,"chunk-6a0d76fd":1,"chunk-4906ca31":1,"chunk-6c336933":1,"chunk-4238b374":1,"chunk-4b38d3e4":1,"chunk-ffbc6fd0":1,"chunk-85226048":1,"chunk-f0163ed2":1,"chunk-fdcdac8a":1,"chunk-81498b9e":1,"chunk-df0d8712":1,"chunk-526b7efe":1,"chunk-6966c2e6":1,"chunk-fd78add2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-19077dac":"cb445c1b","chunk-3a41d492":"3b7bd6c7","chunk-626ba461":"eb4f77b9","chunk-67e42083":"31d6cfe0","chunk-67fad740":"31d6cfe0","chunk-67fb6f57":"31d6cfe0","chunk-7378afc2":"aa316f16","chunk-766bc744":"600a7271","chunk-3f7c25af":"bc071073","chunk-271a77da":"ec57b20a","chunk-3526a310":"faa4063c","chunk-542ae368":"ab327ae4","chunk-743e4b25":"b7e4a7f0","chunk-74524b79":"02574d02","chunk-746154ec":"a30c0971","chunk-7498e9ec":"163ac366","chunk-74a82e1a":"5c34488f","chunk-74b6aca8":"12720cd8","chunk-2eb2cd53":"f60966e5","chunk-76f08193":"492d3632","chunk-771a7e38":"4d5bff5a","chunk-7f466224":"31d6cfe0","chunk-0069aa54":"f5d52696","chunk-297a20f0":"84f98409","chunk-4c24d0d2":"8ceceae0","chunk-6a0d76fd":"6744f076","chunk-2d0d7a57":"31d6cfe0","chunk-2d207762":"31d6cfe0","chunk-4906ca31":"6654b603","chunk-6c336933":"8765fc28","chunk-4238b374":"aed768fd","chunk-4b38d3e4":"c45e9e4a","chunk-ffbc6fd0":"adc0a018","chunk-85226048":"07f478e6","chunk-f0163ed2":"385ad187","chunk-fdcdac8a":"b27cfab6","chunk-81498b9e":"084d66fa","chunk-df0d8712":"b7c5e579","chunk-67e31440":"31d6cfe0","chunk-f42db444":"31d6cfe0","chunk-526b7efe":"2b26dd89","chunk-6966c2e6":"2b26dd89","chunk-fd78add2":"ceb6bbb8"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/segel/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
